export default "__VITE_ASSET__3c0c1407__"